<script setup>
import ChangeOfVolumeTag from "@/components/keyword/partials/ChangeOfVolumeTag.vue";
import TooltipQuestion from "@/components/global-themed/TooltipQuestion.vue";

defineProps({
  text: {
    type: String,
    required: true,
  },
  tooltipText: {
    type: String,
    required: true,
  },
  value: {
    type: Number,
    required: true,
  },
  valueChange: {
    type: [Number, null],
    required: false,
    default: null,
  },
});

const numberFormat = (number) => {
  if (number >= 0) {
    return Number(number).toLocaleString();
  }

  return '0';
}
</script>

<template>
  <div class="tw-border-2 tw-border-grey-mid tw-rounded-lg tw-flex tw-flex-col tw-w-80 tw-h-44 tw-justify-center tw-text-center">
    <div class="tw-flex tw-items-center tw-justify-center tw-gap-3">
      <span class="tw-font-bold tw-text-4.5xl tw-text-primary">{{ numberFormat(value) }}</span>
      <ChangeOfVolumeTag
        v-if="valueChange !== null && valueChange !== undefined"
        :number="valueChange"
      />
    </div>

    <span class="tw-text-grey-dark tw-flex tw-justify-center tw-items-center">
      {{ text }}
      <TooltipQuestion
        class="tw-ml-2"
        :text="tooltipText"
      />
    </span>
  </div>
</template>
